<template>
  <div class="page-wrap">

    <!-- ── Unified Detail Card ──────────────────────── -->
    <div class="unified-detail-card">

      <!-- Header -->
      <div class="udc-header pb-4">
        <div class="udc-profile-top">
          <div class="udc-profile-left">
            <!-- <div class="udc-avatar-wrap" style="border-radius: 16px;">
              <div class="udc-placeholder" style="background: rgba(13,153,114,0.1); color: var(--brand);">
                <v-icon size="32" color="var(--brand)">mdi-crown-outline</v-icon>
              </div>
            </div> -->
            <div class="udc-info">
              <h2 class="udc-name">Membership Plans</h2>
              <div class="udc-meta-row mt-1">
                <div class="udc-meta-item">
                  <v-icon size="14" color="#64748B">mdi-information-outline</v-icon>
                  <span class="udc-meta-text">Manage your society subscription and discover premium features</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="udc-profile-right">
            <button class="udc-back-btn" @click="$router.go(-1)" :style="{ color: 'var(--brand)' }">
              <v-icon size="16" color="var(--brand)">mdi-arrow-left</v-icon> BACK
            </button>
          </div> -->
        </div>
      </div>

      <!-- Content -->
      <div class="udc-content-wrap">

        <!-- ── Status Cards ── -->
        <div class="status-grid mb-8">

          <!-- Current Plan -->
          <div v-if="currentPlan && currentPlan.plan" class="plan-status-card current-active">
            <div class="psc-chip brand-chip">Active Now</div>
            <div class="psc-body">
              <div class="psc-icon-box brand-icon">
                <v-icon size="28" color="var(--brand)">mdi-star-circle-outline</v-icon>
              </div>
              <div class="psc-info">
                <div class="psc-label">Current Subscription</div>
                <h2 class="psc-name">{{ currentPlan.plan.title }}</h2>
                <div class="psc-price">₹{{ Number(currentPlan.amount).toLocaleString() }}</div>
              </div>
            </div>
            <div class="psc-footer">
              <div class="psc-expiry">
                <v-icon size="14" color="#64748B" class="mr-1">mdi-clock-outline</v-icon>
                Expires: {{ getFormattedDate(currentPlan.expiration_date) }}
              </div>
              <div v-if="textShow" class="psc-countdown">
                {{ planDay }} Days Remaining
              </div>
            </div>
          </div>

          <!-- Next Plan -->
          <div v-if="nextPlan && nextPlan.plan && nextPlan.plan.title" class="plan-status-card next-queued">
            <div class="psc-chip blue-chip">Up Next</div>
            <div class="psc-body">
              <div class="psc-icon-box blue-icon">
                <v-icon size="28" color="#3B82F6">mdi-arrow-up-bold-circle-outline</v-icon>
              </div>
              <div class="psc-info">
                <div class="psc-label">Upcoming Renewal</div>
                <h2 class="psc-name">{{ nextPlan.plan.title }}</h2>
                <div class="psc-price">₹{{ Number(userPlan.lessPrice).toLocaleString() }}</div>
              </div>
            </div>
            <div class="psc-footer">
              <div class="psc-expiry">
                <v-icon size="14" color="#64748B" class="mr-1">mdi-calendar-start</v-icon>
                Starts: {{ getFormattedDate(nextPlan.start_date) }}
              </div>
            </div>
          </div>

        </div>

        <!-- ── Available Upgrades ── -->
        <div v-if="textShow === true && showPlan === true">
          <div class="premium-field-label mb-6">Available Upgrades</div>

          <div class="plans-grid">
            <div
              v-for="item in planData"
              :key="item.id"
              class="p-tier-card"
              :class="{ 'tier-purchased': item.id === currentPlan && currentPlan.plan_id }"
            >
              <div class="ptc-header">
                <div class="ptc-icon-bg">
                  <v-icon size="22" :color="item.id === (currentPlan && currentPlan.plan_id) ? 'var(--brand)' : '#F59E0B'">
                    {{ item.id === (currentPlan && currentPlan.plan_id) ? 'mdi-check-decagram' : 'mdi-crown-outline' }}
                  </v-icon>
                </div>
                <h3 class="ptc-title">{{ item.title }}</h3>
              </div>

              <div class="ptc-pricing">
                <div class="ptc-original" v-if="userPlan.totalPrice">₹{{ userPlan.totalPrice }}</div>
                <div class="ptc-now">
                  <span class="curr">₹</span>
                  <span class="val">{{ userPlan.lessPrice }}</span>
                </div>
                <div class="ptc-duration">for {{ item.number_of_days }} days</div>
              </div>

              <v-divider class="my-4" />

              <div class="ptc-features">
                <div class="ptc-feat-item">
                  <v-icon size="15" color="#10B981" class="mr-2">mdi-check-circle</v-icon>
                  <span>Full Society Access</span>
                </div>
                <div class="ptc-feat-item">
                  <v-icon size="15" color="#10B981" class="mr-2">mdi-check-circle</v-icon>
                  <span>Automated Billing</span>
                </div>
                <div class="ptc-feat-item">
                  <v-icon size="15" color="#3B82F6" class="mr-2">mdi-information-outline</v-icon>
                  <span>₹{{ planPrice }} Per House</span>
                </div>
              </div>

              <button
                class="ptc-btn"
                :class="{ 'ptc-btn-purchased': item.id === (currentPlan && currentPlan.plan_id) }"
                @click="item.id === (currentPlan && currentPlan.plan_id) ? null : purchasePlan(item.id)"
                :disabled="item.id === (currentPlan && currentPlan.plan_id)"
              >
                <v-icon v-if="item.id === (currentPlan && currentPlan.plan_id)" size="16" class="mr-1">mdi-check</v-icon>
                {{ item.id === (currentPlan && currentPlan.plan_id) ? 'Current Plan' : 'Upgrade Society' }}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: 'MyPlans',
  data() {
    return {
      planData: [],
      currentPlan: {},
      nextPlan: {},
      showPlan: false,
      planDay: 0,
      textShow: false,
      userPlan: {},
      planPrice: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState('theme', ['isDark', 'primaryColor']),
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getPlan() {
      this.$axios.get("societyadmin/plans").then((response) => {
        let data = response.data;
        if (data.status) {
          this.planData = data.Plan;
        } else {
          this.showError(data.message);
        }
      });
    },

    getUserPlan() {
      this.$axios.get("societyadmin/user-plan").then((response) => {
        let data = response.data;
        if (data.status) {
          this.currentPlan = data.current || {};
          this.nextPlan    = data.next    || {};
          this.showPlan    = data.showPlan;
          this.textShow    = data.textShow;
          this.planDay     = data.planDay;
          this.userPlan    = data.planData;
          this.planPrice   = data.planPrice;
          if (!data.isExpired) {
            localStorage.removeItem("isPlanExpired");
          } else {
            localStorage.setItem("isPlanExpired", "true");
          }
        } else {
          this.showError(data.message);
        }
      });
    },

    purchasePlan(id) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          this.$axios.post("/societyadmin/plan-purchase", { plan_id: id })
            .then((response) => {
              let data = response.data;
              this.loading = false;
              if (data.status) {
                this.setAlert({ showAlert: true, message: data.message, variant: "green accent-4", timeout: 3000 });
                setTimeout(() => { window.location.reload(); }, 2000);
              } else {
                this.showError(data.message || (data.errors ? data.errors[0].message : "Purchase failed"));
              }
            }).catch(() => { this.loading = false; });
        }
      });
    },

    getFormattedDate(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
    },

    showError(msg) {
      this.setAlert({ showAlert: true, variant: "red accent-3", timeout: "2000", message: msg });
    }
  },
  mounted() {
    this.getPlan();
    this.getUserPlan();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 24px;
}

/* ── Unified Detail Card ── */
.unified-detail-card {
  background: var(--surface);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
}

/* Header */
.udc-header {
  padding: 16px 16px 0 16px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}
.udc-profile-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
.udc-profile-left {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.udc-avatar-wrap {
  width: 72px; height: 72px;
  border-radius: 50%; overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  flex-shrink: 0;
  background: var(--surface2);
}
.udc-placeholder {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
}
.udc-info { flex: 1; }
.udc-name {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-size: 16px; font-weight: 700;
  color: var(--tx); margin: 0; letter-spacing: -0.01em;
}
.udc-meta-row { display: flex; align-items: center; flex-wrap: wrap; gap: 14px; }
.udc-meta-item { display: flex; align-items: center; gap: 6px; }
.udc-meta-text { font-size: 13.5px; color: var(--tx2); font-weight: 500; }

/* Back Button */
.udc-back-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 0 14px 0 10px !important;
  font-weight: 700 !important; font-size: 12px !important;
  letter-spacing: 0.05em !important; border-radius: 8px !important;
  border: 1px solid var(--border) !important;
  background: var(--surface2) !important;
  height: 38px !important; cursor: pointer;
  transition: all 0.2s;
}
.udc-back-btn:hover {
  background: var(--surface2) !important;
  border-color: var(--brand) !important;
}

/* Content Area */
.udc-content-wrap {
  background: var(--surface2);
  min-height: 300px;
  padding: 16px;
}

.premium-field-label {
  font-size: 12px; font-weight: 700;
  color: var(--tx3, #64748B);
  text-transform: uppercase; letter-spacing: 0.05em;
}

/* ── Status Cards ── */
.status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.plan-status-card {
  position: relative;
  border-radius: 16px;
  padding: 24px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}
.plan-status-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
}
.current-active::before {
  content: "";
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: var(--brand, #0D9972);
}
.next-queued::before {
  content: "";
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: #3B82F6;
}

.psc-chip {
  position: absolute; top: 16px; right: 20px;
  padding: 4px 12px; border-radius: 20px;
  font-size: 10px; font-weight: 800;
  text-transform: uppercase; letter-spacing: 0.06em;
}
.brand-chip { background: rgba(13,153,114,0.1); color: var(--brand, #0D9972); }
.blue-chip  { background: rgba(59,130,246,0.1); color: #3B82F6; }

.psc-body { display: flex; align-items: center; gap: 16px; margin: 8px 0 20px; }
.psc-icon-box {
  width: 56px; height: 56px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.brand-icon { background: rgba(13,153,114,0.08); }
.blue-icon  { background: rgba(59,130,246,0.08); }

.psc-info { flex: 1; }
.psc-label {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--tx3);
}
.psc-name { font-size: 20px; font-weight: 800; margin: 4px 0 2px; color: var(--tx); }
.psc-price { font-size: 22px; font-weight: 800; color: var(--tx2); letter-spacing: -0.02em; }

.psc-footer {
  display: flex; align-items: center; justify-content: space-between;
  border-top: 1px solid var(--border); padding-top: 16px;
}
.psc-expiry { font-size: 13px; font-weight: 600; color: var(--tx2); display: flex; align-items: center; }
.psc-countdown {
  font-size: 12px; font-weight: 700;
  background: var(--surface2); color: var(--tx2);
  padding: 5px 12px; border-radius: 8px; border: 1px solid var(--border);
}

/* ── Upgrade Plans Grid ── */
.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.p-tier-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 28px;
  display: flex; flex-direction: column;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.p-tier-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px rgba(0,0,0,0.05);
  border-color: var(--brand, #0D9972);
}
.tier-purchased { opacity: 0.85; }
.tier-purchased::after {
  content: "";
  position: absolute; inset: -1px;
  border: 2px solid var(--brand, #0D9972);
  border-radius: 16px; pointer-events: none;
}

.ptc-header { display: flex; align-items: center; gap: 14px; margin-bottom: 20px; }
.ptc-icon-bg {
  width: 48px; height: 48px; border-radius: 12px;
  background: var(--surface2);
  display: flex; align-items: center; justify-content: center;
}
.ptc-title { font-size: 17px; font-weight: 800; margin: 0; color: var(--tx); }

.ptc-pricing { margin-bottom: 20px; }
.ptc-original { text-decoration: line-through; color: var(--tx4); font-size: 13px; font-weight: 600; margin-bottom: 2px; }
.ptc-now { display: flex; align-items: flex-start; gap: 3px; color: var(--tx); }
.ptc-now .curr { font-size: 18px; font-weight: 700; margin-top: 5px; color: var(--tx3); }
.ptc-now .val  { font-size: 40px; font-weight: 800; line-height: 1; letter-spacing: -0.03em; }
.ptc-duration  { font-size: 13px; color: var(--tx3); font-weight: 600; margin-top: 6px; }

.ptc-features { flex: 1; display: flex; flex-direction: column; gap: 12px; margin-bottom: 28px; }
.ptc-feat-item { display: flex; align-items: center; font-size: 13.5px; color: var(--tx2); font-weight: 600; }

.ptc-btn {
  width: 15%; height: 44px; border-radius: 10px; border: none;
  background: var(--btn-color); color: #fff;
  font-size: 13px; font-weight: 700; cursor: pointer;
  transition: all 0.2s; letter-spacing: 0.02em;
  display: flex; align-items: center; justify-content: center;
}
.ptc-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(13,153,114,0.2);
}
.ptc-btn-purchased {
  background: rgba(13,153,114,0.1);
  color: var(--brand, #0D9972);
  cursor: default;
}
.ptc-btn-purchased:hover { transform: none; filter: none; box-shadow: none; }

/* Responsive */
@media (max-width: 768px) {
  .udc-profile-top { flex-direction: column; align-items: flex-start; gap: 16px; }
  .udc-profile-left { flex-direction: column; align-items: flex-start; gap: 16px; }
  .udc-content-wrap { padding: 16px; }
  .status-grid { grid-template-columns: 1fr; }
}
</style>
